import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";

export default {
    primary(message, duration = 3000) {
        Toastify({
            text: message,
            duration: duration,
            gravity: "top",
            offset: { y: 50 },
            position: "center",
            style: {
                background: "var(--ion-color-custom-white)",
                color: "var(--ion-color-dark)",
                borderRadius: "15px",
            },
        }).showToast();
    },
    success(message, duration = 3000) {
        Toastify({
            text: message,
            duration: duration,
            gravity: "top",
            offset: { y: 50 },
            position: "center",
            style: {
                background: "var(--ion-color-custom-white)",
                color: "var(--ion-color-success)",
                borderRadius: "15px",
            },
        }).showToast();
    },
    error(message, duration = 3000) {
        Toastify({
            text: message,
            duration: duration,
            gravity: "top",
            offset: { y: 50 },
            position: "center",
            style: {
                background: "var(--ion-color-custom-white)",
                color: "var(--ion-color-danger)",
                borderRadius: "15px",
            },
        }).showToast();
    },
    info(message, duration = 3000) {
        Toastify({
            text: message,
            duration: duration,
            gravity: "top",
            offset: { y: 50 },
            position: "center",
            style: {
                background: "var(--ion-color-custom-white)",
                color: "var(--ion-color-medium)",
                borderRadius: "15px",
            },
        }).showToast();
    },

    warning(message, duration = 3000) {
        Toastify({
            text: message,
            duration: duration,
            gravity: "top",
            offset: { y: 50 },
            position: "center",
            style: {
                background: "var(--ion-color-custom-white)",
                color: "var(--ion-color-warning)",
                borderRadius: "15px",
            },
        }).showToast();
    },
};
